export default __webpack_public_path__ + "static/media/frown-regular.37b476b5.svg";